<h3 class="title-divider mb-1">{{ heading | translate }}</h3>

@if (model && model.mFileSelection.access === "ALLOWED") {
  <cap-auftrag-grundstueck-identifikatoren-selection
    [(ngModel)]="model"
    [fileName]="model?.fileSelection?.fileName"
    [readonly]="readonly"
    name="auftrag-grundstueck-identifikatoren">
  </cap-auftrag-grundstueck-identifikatoren-selection>
} @else {
  <ng-container>
    <cap-auftrag-gemeinde-selection [(ngModel)]="model" [readonly]="readonly" name="auftrag-gemeinde"></cap-auftrag-gemeinde-selection>
  </ng-container>
}
